var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteToUsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 43.2,
    height: 43.2,
    rx: 4.6,
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 22L30.0891 15.9225C30.3558 15.6557 30.5057 15.2939 30.5057 14.9167C30.5057 14.5394 30.3558 14.1776 30.0891 13.9108C29.8223 13.6441 29.4605 13.4942 29.0832 13.4942C28.706 13.4942 28.3442 13.6441 28.0774 13.9108L21.9999 20.0025L15.9224 13.9108C15.6557 13.6441 15.2938 13.4942 14.9166 13.4942C14.5393 13.4942 14.1775 13.6441 13.9107 13.9108C13.644 14.1776 13.4941 14.5394 13.4941 14.9167C13.4941 15.2939 13.644 15.6557 13.9107 15.9225L20.0024 22L13.9107 28.0775C13.778 28.2092 13.6726 28.3659 13.6007 28.5385C13.5287 28.7111 13.4917 28.8963 13.4917 29.0833C13.4917 29.2703 13.5287 29.4555 13.6007 29.6281C13.6726 29.8008 13.778 29.9575 13.9107 30.0892C14.0424 30.2219 14.1991 30.3273 14.3718 30.3993C14.5444 30.4712 14.7296 30.5082 14.9166 30.5082C15.1036 30.5082 15.2888 30.4712 15.4614 30.3993C15.634 30.3273 15.7907 30.2219 15.9224 30.0892L21.9999 23.9975L28.0774 30.0892C28.2091 30.2219 28.3658 30.3273 28.5384 30.3993C28.7111 30.4712 28.8962 30.5082 29.0832 30.5082C29.2703 30.5082 29.4554 30.4712 29.6281 30.3993C29.8007 30.3273 29.9574 30.2219 30.0891 30.0892C30.2219 29.9575 30.3273 29.8008 30.3992 29.6281C30.4711 29.4555 30.5081 29.2703 30.5081 29.0833C30.5081 28.8963 30.4711 28.7111 30.3992 28.5385C30.3273 28.3659 30.2219 28.2092 30.0891 28.0775L23.9974 22Z",
    fill: "#232738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteToUsClose);
export default __webpack_public_path__ + "static/media/write-to-us-close.b52cd988e6dce715d4564129607e5b60.svg";
export { ForwardRef as ReactComponent };